<template>
  <section class="radio-button" :class="{'radio-button--ac': ac}" >
    <input
      type="radio"
      :id="elementId"
      :name="name"
      :value="value"
      :checked="checked"
      v-model="radioValue"
    />
    <label :for="elementId">{{ label }}</label>
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  import uniqueID from '@/helpers/uniqueID'

  export default {
    model: {
      prop: 'checkedValue',
      event: 'change'
    },
    props: {
      label: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: String,
        required: true
      },
      checked: {
        type: Boolean,
        default: false
      },
      checkedValue: {
        type: String,
        default: ''
      }
    },
    computed: {
      elementId() {
        if (this.id) {
          return this.id
        } else {
          return uniqueID('radio')
        }
      },
      radioValue: {
        get() {
          return this.checkedValue
        },
        set(value) {
          this.$emit('change', value)
        }
      },
      ...mapState({
        ac: state => state.ac
      })
    }
  };
</script>

<style lang="scss" scoped>
  .radio-button {
    position: relative;

    input {
      position: absolute;
      left: 0;
      top: 50%;
      display: inline-block;
      width: 24px;
      height: 24px;
      margin: 0;
      padding: 0;
      transform: translateY(-50%);
      z-index: 3;
      opacity: 0;
    }

    label {
      display: flex;
      align-items: center;
      min-height: 24px;
      margin: 0;
      padding: 5px 0 5px 36px;
      color: #181818;
      text-align: left;
      font-family: timsans_regular;
      font-size: 0.9375rem;
      line-height: normal;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        display: inline-block;
        width: 24px;
        height: 24px;
        transform: translateY(-50%);
        z-index: 1;
        border: 1px solid #cecece;
        border-radius: 12px;
        box-sizing: border-box;
      }

      &:after {
        content: '';
        position: absolute;
        left: 5px;
        top: 50%;
        display: none;
        width: 14px;
        height: 14px;
        transform: translateY(-50%);
        z-index: 2;
        background: #003091;
        border-radius: 12px;
        box-sizing: border-box;
      }
    }

    input:checked + label {
      &:after {
        display: inline-block;
      }
    }
  }

  .radio-button--ac.radio-button {
    label {
      color: #FFFFFF;

      &:before {
        border: 1px solid #FFFFFF;
      }

      &:after {
        background: #FFFF00;
      }
    }
  }
</style>